import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import './App.less'
import AuthRouter from './routers/authRouter'
import Router from './routers'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
function App() {
    return (
        <BrowserRouter>
            <AuthRouter>
                <Router />
            </AuthRouter>
        </BrowserRouter>
    )
}
export default App
